// @ts-nocheck

import { map } from 'lodash';

import { selectEntitiesMatchesEntity } from '../../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { type StateType } from '../../../states';
import { MatchEntity, MatchEntityStatus } from '../../../states/entities/matches';
import Selection from '../states/selection';
import { GridsCheckTypes } from '../types';

import { getGrid } from './grids';
import { isLiveIsOvertime } from './matches';
import { getPool, getPoolMatchesIds, getPoolResultSelection } from './pool';

export const editableGridSelector = (state: StateType, { poolId }: { poolId: number }) => {
  const { selections } = state.grids.basket;
  return {
    matches: getPoolMatchesIds(state, poolId),
    selection: (selections && selections[0]) || null,
  };
};

export const editableSystemGridSelector = (
  state: StateType,
  { poolId, isReadOnly = false }: { poolId: number; isReadOnly: boolean },
) => {
  return {
    matches: getPoolMatchesIds(state, poolId),
    isSystemCompact: isReadOnly,
  };
};

export const closedPoolSelector = (state: StateType, { poolId }: { poolId: number }) => {
  return {
    matches: getPoolMatchesIds(state, poolId),
    selection: getPoolResultSelection(state, poolId),
    isClosedPool: true,
  };
};

export const historyGridSelector = (state: StateType, { gridReference }: { gridReference: string }) => {
  const grid = getGrid(state, gridReference);
  const pool = grid ? getPool(state, grid.poolId) : null;

  const isSystem = !!grid?.isSystem || false;

  let selection = grid?.strGridSelection || null;
  if (grid && grid.systemStrGridSelections && isSystem) {
    selection = Selection.getCompactSystem(grid.systemStrGridSelections) || null;
  }

  const matches = pool?.matches || [];
  const resultSelection = pool?.strPoolResult || null;

  return {
    matches,
    selection,
    isSystem,
    resultSelection,
    isSystemCompact: isSystem,
  };
};

export const getChecks = (
  matchIndex: number,
  selection: string,
  resultSelection: string | null,
  isSystemCompact: boolean,
) =>
  map(GridsCheckTypes, (typeCheck) => {
    let isChecked = Selection.isChecked(selection, matchIndex, typeCheck);
    let isCheckedButNoBase = false;

    if (isSystemCompact) {
      const isBase = Selection.isBase(selection, matchIndex, typeCheck);
      isCheckedButNoBase = isChecked && !isBase;
      isChecked = isBase;
    }

    const hasOccured = resultSelection ? Selection.isChecked(resultSelection, matchIndex, typeCheck) : null;

    return {
      typeCheck,
      isCheckedButNoBase,
      isChecked,
      hasOccured,
    };
  });

type GridLineProps = {
  matchId: number;
  selection: string;
  resultSelection: string;
  matchIndex: number;
  isSystemCompact: boolean;
  isClosedPool: boolean;
  hideInfo: boolean;
  isBasket: boolean;
};

export const getGridLine = (state: StateType, props: GridLineProps) => {
  const { matchId, selection, resultSelection, matchIndex, isSystemCompact, isClosedPool, hideInfo, isBasket } = props;

  let checks = [];
  let isLive = false;
  let isCancelled = false;
  let isWinningLine = false;
  let isWin = false;
  let isLost = false;
  let competitor1 = '';
  let competitor2 = '';

  const match = selectEntitiesMatchesEntity(state, { matchId });

  if (match) {
    const { status: matchStatus, competitor1Name, competitor2Name } = match;
    isLive = MatchEntityStatus.isLive(matchStatus) && !isLiveIsOvertime(state, matchId);
    isCancelled = MatchEntity.isGridCancelled(match);
    isWinningLine = Selection.isWinningLine(selection, resultSelection, matchIndex);
    const finalResultSelection = resultSelection;
    checks = getChecks(matchIndex, selection, finalResultSelection, isSystemCompact);
    competitor1 = competitor1Name;
    competitor2 = competitor2Name;
    isWin = isClosedPool ? false : isWinningLine;
    isLost = isClosedPool ? false : !isWinningLine;
  }
  return {
    checks,
    isLive,
    isCancelled,
    isWin,
    isLost,
    showInfo: !hideInfo && !isBasket,
    competitor1,
    competitor2,
  };
};
